import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let DataProtectionService = class DataProtectionService {
    constructor(dataProtectionApi) {
        this.dataProtectionApi = dataProtectionApi;
        this.disbaleRestriction = (data) => this.dataProtectionApi.disbaleRestriction(data);
    }
    // #region Export Management
    getRuleConfigList() {
        return this.dataProtectionApi.getRuleConfigList();
    }
    getConfigList(params) {
        return this.dataProtectionApi.getConfigList(params);
    }
    saveToConfigure(data) {
        return this.dataProtectionApi.saveToConfigure(data);
    }
    editToConfigure(id) {
        return this.dataProtectionApi.editToConfigure(id);
    }
    useDetail(configId) {
        return this.dataProtectionApi.useDetail(configId);
    }
    deleteToConfigure(config_id) {
        return this.dataProtectionApi.deleteToConfigure(config_id);
    }
    // #endregion
    // #region Restriction List
    getRestrictionList(params) {
        return this.dataProtectionApi.getRestrictionList(params);
    }
    relieveRestriction(data) {
        return this.dataProtectionApi.relieveRestriction(data);
    }
    getRestrictionDetails(params) {
        return this.dataProtectionApi.getRestrictionDetails(params);
    }
    // #endregion
    // #region Company Tree
    queryCompanyInfo(data) {
        return this.dataProtectionApi.queryCompanyInfo(data);
    }
    queryKeyWord(data) {
        return this.dataProtectionApi.queryKeyWord(data);
    }
};
DataProtectionService = __decorate([
    injectable(),
    __param(0, inject(Symbols.DataProtectionApi)),
    __metadata("design:paramtypes", [Object])
], DataProtectionService);
export { DataProtectionService };
